<template>
    <div>

        <section class="section section-shaped section-md my-0 section-header-pages single-region">
            <div class="shape shape-style-1 bg-gradient-default">
                <span></span>
                <span></span>
                <span style="visibility:hidden"></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container shape-container d-flex">
                <div class="col px-0">
                    <div class="row">
                       <div class="col-md-12">
                         ERROR
                       </div>
                    </div>
                </div>
            </div>
        </section>
        
        <section class="section section-md">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-lg-12">
                        <div class="">                            
                        </div>
                    </div>
                </div>
            </div>
        </section> 

    </div>
</template>

<script>

export default {
  name: "error404",
  mounted() {   
    
  },
  
};
</script>